"use strict";

require( "./bug.support.js" );
require( "./echo.support.js" );
require( "./failed.support.js" );
require( "./fatal.support.js" );
require( "./issue.support.js" );
require( "./prompt.support.js" );
require( "./record.support.js" );
require( "./redundant.support.js" );
require( "./success.support.js" );
require( "./uncertain.support.js" );
require( "./warning.support.js" );

module.exports = require( "./olivant.support.js" );



//////////////////
// WEBPACK FOOTER
// ./browser.js
// module id = 272
// module chunks = 0